const titles = {
  hiragana: {
    seion: "平假名 - 清音",
    youon: "平假名 - 拗音",
    dakuon_handaon: "平假名 - 濁音與半濁音",
    all: "平假名 - 全部"
  },
  katakana: {
    seion: "片假名 - 清音",
    youon: "片假名 - 拗音",
    dakuon_handaon: "片假名 - 濁音與半濁音",
    all: "片假名 - 全部"
  },
  all_kanas: {
    all: "全部 50 音"
  }
};

export default titles;
